import stanislavUrl from '../images/team/no-poster-available1.jpg';
import stanislavPhoto from '../images/team/no-poster-available.jpg';
import nastyaUrl from '../images/team/Nastya Ovcharenko.jpg';
import nastyaPhoto from '../images/team/no-poster-available.jpg';
import serhiiUrl from '../images/team/no-poster-available1.jpg';
import serhiiPhoto from '../images/team/no-poster-available.jpg';
import irynaUrl from '../images/team/Iryna.jpg';
import irynaPhoto from '../images/team/no-poster-available.jpg';
import mykolaUrl from '../images/team/Kuts Mykola1.jpg';
import mykolaPhoto from '../images/team/no-poster-available.jpg';
import nataliiaUrl from '../images/team/Nataliia Matsko2.jpg';
import nataliiaPhoto from '../images/team/no-poster-available.jpg';
import ruslanUrl from '../images/team/Ruslan.jpg';
import ruslanPhoto from '../images/team/no-poster-available.jpg';
import alonaUrl from '../images/team/no-poster-available1.jpg';
import alonaPhoto from '../images/team/no-poster-available.jpg';
import vadymUrl from '../images/team/Vadym.jpg';
import vadymPhoto from '../images/team/no-poster-available.jpg';
import anastasiiaUrl from '../images/team/Anastasiia.jpg';
import anastasiiaPhoto from '../images/team/no-poster-available.jpg';
import tarasUrl from '../images/team/no-poster-available1.jpg';
import tarasPhoto from '../images/team/no-poster-available.jpg';
import tetianaUrl from '../images/team/no-poster-available1.jpg';
import tetianaPhoto from '../images/team/no-poster-available.jpg';
import oleksiiUrl from '../images/team/no-poster-available1.jpg';
import oleksiiPhoto from '../images/team/no-poster-available.jpg';

export const galleryTeam = [
  {
    id: 1,
    name: 'Stanislav Zaliskyi',
    photoPreview: `${stanislavUrl}`,
    photo: `${stanislavPhoto}`,
    position: 'Team Lead',
  },
  {
    id: 2,
    name: 'Nastya Ovcharenko',
    photoPreview: `${nastyaUrl}`,
    photo: `${nastyaPhoto}`,
    position: 'Scrum Master',
  },
  {
    id: 3,
    name: 'Serhii Lytvynenko',
    photoPreview: `${serhiiUrl}`,
    photo: `${serhiiPhoto}`,
    position: 'Developer',
  },
  {
    id: 4,
    name: 'Iryna Borysova',
    photoPreview: `${irynaUrl}`,
    photo: `${irynaPhoto}`,
    position: 'Developer',
  },
  {
    id: 5,
    name: 'Mykola Kuts',
    photoPreview: `${mykolaUrl}`,
    photo: `${mykolaPhoto}`,
    position: 'Developer',
  },
  {
    id: 6,
    name: 'Nataliia Matsko',
    photoPreview: `${nataliiaUrl}`,
    photo: `${nataliiaPhoto}`,
    position: 'Developer',
  },
  {
    id: 7,
    name: 'Ruslan Borysevych',
    photoPreview: `${ruslanUrl}`,
    photo: `${ruslanPhoto}`,
    position: 'Developer',
  },
  {
    id: 8,
    name: 'Alona Neshodym',
    photoPreview: `${alonaUrl}`,
    photo: `${alonaPhoto}`,
    position: 'Developer',
  },
  {
    id: 9,
    name: 'Vadym Kolisnyk',
    photoPreview: `${vadymUrl}`,
    photo: `${vadymPhoto}`,
    position: 'Developer',
  },
  {
    id: 10,
    name: 'Anastasiia Berehovyh',
    photoPreview: `${anastasiiaUrl}`,
    photo: `${anastasiiaPhoto}`,
    position: 'Developer',
  },
  {
    id: 11,
    name: 'Taras Fedak',
    photoPreview: `${tarasUrl}`,
    photo: `${tarasPhoto}`,
    position: 'Developer',
  },
  {
    id: 12,
    name: 'Tetiana Asadova',
    photoPreview: `${tetianaUrl}`,
    photo: `${tetianaPhoto}`,
    position: 'Developer',
  },
  {
    id: 13,
    name: 'Oleksii Mikhieiev',
    photoPreview: `${oleksiiUrl}`,
    photo: `${oleksiiPhoto}`,
    position: 'Developer',
  },
];
